import React from 'react';

import {PageWrapperLayout} from 'presentation/components';
import {FlowEnum} from 'presentation/pages/private/booking/constants';
import {translations} from 'presentation/translations-new';
import {MakeCitySelection} from 'main/factories/pages';

const {healthGuideAll} = translations['pt-br'].privateFlow.services;

export function OdontoGuideCities() {
	return (
		<PageWrapperLayout title={healthGuideAll}>
			<MakeCitySelection flowType={FlowEnum.ODONTO_GUIDE} />
		</PageWrapperLayout>
	);
}
